import * as yup from 'yup';

import { LC_PAGE_SUBJECT_CHAR_LIMIT } from '@lessonPlanner/constants';

interface MultigradeFormData {
  gradeLevel: string;
  subject: string;
  lessonFormat?: string;
  objective: string;
  objective2?: string;
  objective3?: string;
  language: string;
}

const charLimitTest = (limit: number) => (val: string) =>
  !val || val.length <= limit;

const MultigradeSchema = yup.object<MultigradeFormData>().shape({
  gradeLevel: yup.string().required('Please select a grade level'),
  subject: yup
    .string()
    .required('Please enter a subject')
    .test(
      'len',
      'You have reached the character limit',
      charLimitTest(LC_PAGE_SUBJECT_CHAR_LIMIT),
    ),
  lessonFormat: yup.string().when('gradeLevel', {
    is: (gradeLevel) => gradeLevel !== 'College',
    then: (schema) => schema.required('Lesson Format is required'),
    otherwise: (schema) => schema.nullable(),
  }),
  objective: yup.string().required('Please enter an objective'),
  objective2: yup.string().optional(),
  objective3: yup.string().optional(),
  language: yup.string().required('Please select a translation'),
});

export default MultigradeSchema;
